export { stringValidation } from './stringValidation'
export { passwordValidation } from './passwordValidation'
export { confirmPasswordValidation } from './confirmPasswordValidation'
export { emailValidation } from './emailValidation'
export { nameValidation } from './nameValidation'
export {
  phoneNumberValidation,
  phoneNumberOptionalValidation,
} from './phoneNumberValidation'
export { dropdownValidation } from './dropDownValidation'
